<template>
  <div v-if="$store.state.isUserLoggedIn">
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <v-sheet v-if="!loading" :rounded="isSmallerDisplay() ? '' : 'lg'" class="pt-2">
      <v-card elevation="0" style="margin-bottom: 15px;">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined small class="elevation-0" @click="goToTimer()" color="primary">
            <v-icon class="mr-1">mdi-clock-plus-outline</v-icon>
            {{ $t("message.add_timer") }}
          </v-btn>
        </v-card-actions>
        <v-list v-if="timers.length" two-line class="pa-0">
          <template v-for="(i, index) in timers">
            <v-list-item :key="'timer' + index" @click="goToTimer(i)">
              <v-list-item-content>
                <v-list-item-title class="text-subtitle-1 primary--text">
                  {{ i.name }}
                </v-list-item-title>
                <v-list-item-title class="supporting-text">
                  {{ $t("message.total_time") }}: {{ seconds2Minutes(i.totalTime) }}
                </v-list-item-title>
                <v-list-item-subtitle class="supporting-text" v-if="i.advanced">
                  <v-icon size="20" color="accent" v-if="i.cla">mdi-gamepad-variant-outline</v-icon>
                  <v-icon size="20" color="accent" v-else>mdi-timer-cog-outline</v-icon>
                  {{ $t("message.intervals_with_rounds", [i.intervals.length]) }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="supporting-text" v-else-if="i.intervals[0]">
                  {{ i.intervals[0].rounds }} {{ $t("message.rounds") }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="index + 1 < timers.length" :key="index"></v-divider>
          </template>
        </v-list>
        <v-card-text v-else class="text-center">
          <div class="text-subtitle-1">
            {{ $t("message.empty_list") }}
          </div>
          <div>
            <v-btn text large class="elevation-0" @click="goToTimer()" color="primary">
              {{ $t("message.add_timer") }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import TimerService from "@/services/TimerService";

export default {
  name: 'ViewTimers',
  components: {
  },
  data() {
    return {
      loading: true,
      timers: [],
    };
  },
  created() {
    this.getTimers();
  },
  methods: {
    goToTimer(t) {
      if (t)
        this.navigateTo({ name: 'managetimer', params: { timerId: t._id } });
      else
        this.navigateTo({ name: 'managetimer', params: { timerId: 'new' } });
    },
    getTimers() {
      TimerService.getTimers()
        .then((data) => {
          if (data) {
            this.timers = data.timers;
          }
          this.loading = false;
        });
    },
  },
};
</script>
